import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { AppService } from '../app.service';

interface OAuthTokenResult {
  access_token: string;
  expires_in: number;
  token_type: string;
}

@Injectable({
  providedIn: 'root',
})
export class AccessTokenService {
  private expiration: Date;
  private tokenValue: string;

  constructor(
    private readonly appService: AppService,
    private readonly http: HttpClient,
  ) {}

  private getAuthTokenUrl(path: string): Observable<string> {
    return this.appService.getUserDetails().pipe(map((details) => `${details.loginSiteBaseUrl}${path}`));
  }

  getAccessToken(): Observable<string> {
    if (this.tokenValue && this.expiration.valueOf() > Date.now()) {
      return new Observable<string>((observer) => observer.next(this.tokenValue));
    } else {
      return this.getAuthTokenUrl('/Auth/Token').pipe(
        switchMap((url) =>
          this.http.get(url, { withCredentials: true }).pipe(
            tap((data: OAuthTokenResult) => {
              this.tokenValue = data.access_token;
              this.expiration = new Date(Date.now() + data.expires_in * 1000);
            }),
            map((data: OAuthTokenResult) => data.access_token),
          ),
        ),
      );
    }
  }
}
